<ig-row class="tour-info-row">

    <ig-col class="travel-mode" [xs]="6" [md]="6"><mat-icon>{{travelModeIcon}}</mat-icon>{{tour.attractions.length}}
        stops, {{totalTravelTimeText}}</ig-col>
    <ig-col class="travel-mode" [xs]="6" [md]="6">{{totalDistanceMiles}} / {{totalDistanceKM}}</ig-col>

</ig-row>

<div #attraction class="attractions">
    <div class="attraction-no-item" *ngIf="type==='tour'&&!tour.attractions.length">No Items in This Itinerary
    </div>

    <ng-container>

        <div #attractionwrap *ngFor="let attraction of tour.attractions; let ind = index" draggable
            [dragScope]="'items'" [dragEnabled]="isDraggable" droppable [dropScope]="'items'" [dragData]="attraction"
            (onDrag)="startDrag($event)" (onDragOver)="dragEnter($event)" (onDrop)="onItemDrop($event, ind)"
            class="attraction-wrap">
            <div *ngIf="!isDragging" class="flex relative">
                <div style="width:33%" (click)="showDetails(attraction)" role="button" aria-label="view details">
                    <!--<img class="tour-item-image"-->
                    <!--[src]="imageService.safeImage(imageService.imageSource(attraction.item))"-->
                    <!--alt="item image">-->
                    <ig-image class="tour-item-image" [imageUrl]="attraction.item.cover?.source"></ig-image>
                </div>
                <div style="width:calc(66% - 28px);padding:0 20px 0 8px;" (click)="showDetails(attraction)">
                    <div class="attraction-title" matTooltip="{{attraction.item.name}}">
                        {{attraction.item.name}}
                    </div>
                    <div class="attraction-time"
                        matTooltip="{{attraction.item.address.address||attraction.item.address}}">
                        {{attraction.item.address.address||attraction.item.address}}
                    </div>
                    <div class="attraction-time">{{attraction.item.startTimeFormatted}}</div>
                    <div add *ngIf="!isDisabled" [class.hide]="!isDraggable" class="red-btn-div btn-div"
                        (click)="removeFromTour($event, attraction.feedId)" role="button">Remove
                    </div>
                </div>
                <div class="tour-item-number" style="float: none!important;position: absolute;right:0;top:6px;">
                    {{ind+1}}
                </div>
                <div #swaps *ngIf="!isDisabled&&ind!==tour.attractions.length-1" (click)="swap(ind)" class="item-swap">
                    <mat-icon>swap_vert</mat-icon>
                </div>
            </div>
            <div *ngIf="isDragging" class="relative gray-text">{{attraction.item.name}}
                <div class="tour-item-number" style="float: none!important;position: absolute;right:0;top:-5px;">
                    {{ind+1}}
                </div>
            </div>
        </div>
    </ng-container>

    <div class="mask" *ngIf="isUpdating"></div>
    <ig-spinner class="spinner" *ngIf="isUpdating"></ig-spinner>
</div>


<ng-container class="attraction-detail-wrap">
    <ig-trip-float-detail #details [showOperation]="true" [showAddToTrip]="isShowAddtoMyTrip"
        (onAddToTrip)="addToTrip($event)" (onClosing)="floatDetailClose()"
        (onRemoveFromTrip)="removeFromTripAtTour($event)"></ig-trip-float-detail>
</ng-container>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/tours/attractions/attraction.list.component.html